import classNames from "classnames";
import React from "react";
import DocumentObjectTypeIcon from "../documentObjectTypeIcon";
export default function DocumentObjectType(props) {
    return (React.createElement("div", { className: classNames("inline-grid-cols-auto no-gap v-align-inherit", props.className) },
        React.createElement(DocumentObjectTypeIcon, { className: classNames(props.data.DocumentObjectName && "mr-0_5"), documentObjectIconId: props.data.DocumentObjectIconId, documentObjectName: props.data.DocumentObjectName }),
        props.data.DocumentObjectName && (React.createElement("div", { className: "text-overflow-ellipsis" }, props.data.DocumentObjectName))));
}
